import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiHomeLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import Select from '@/components/ui/kit/Select';
import useRemoteDebugCommand from '@/hooks/command/dji/useRemoteDebugCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeDJICommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(true);
  const [isProcessing, setProcessing] = useState(false);
  const remoteDebugCommand = useRemoteDebugCommand();

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeDJICommand(robot, remoteDebugCommand.dockCanopy(isOpen));

      onSuccess(robot);
    } catch (error) {
      if (typeof error === 'object' && error?.data?.message) {
        console.debug(error.data.message);
      }
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  const onSuccess = (robot) => {
    notifier.success(`${robot.name} dock ${isOpen ? 'open' : 'close'} successfully.`);
    setProcessing(false);
  };

  const onFailure = (robot) => {
    notifier.error(`Failed to ${isOpen ? 'open' : 'close'} dock of ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    process(robots[0]);
  }, [isProcessing]);

  const handleChange = (e) => {
    setOpen(e.target.value);
  };

  const doCommand = () => {
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Opens or closes the dock cover</div>
      <div className={cx('form')}>
        <Select name="action" value={isOpen} onChange={handleChange}>
          <option value={true}>Open</option>
          <option value={false}>Close</option>
        </Select>
      </div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Dock Canopy';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiHomeLine;
Command.Panel = Panel;

export default Command;
